// React
import * as React from "react";
import Tippy from '@tippyjs/react';

// Internal components
import { isDefined, IsNullOrWhiteSpace, IsNullOrEmpty } from '@Utils/Micro';
import './IconTextButton.less';
// -------------------------------------------------------------------------------------------------
export interface IconTextButtonData {
    /**
     *  Button data
     */
    button?: ButtonData;
    index?: number;
    groupIndex?: number;
    onIconClick?: (button?: ButtonData, GroupIndex?: number) => void;

    /**
     * Set style per button
     */
    style?: React.CSSProperties;

    /*
     *    Styling settings for icon.
     */
    iconStyle?: React.CSSProperties;

    /*
    *    Styling settings for icon caption.
    */
    captionStyle?: React.CSSProperties;

    /*
    *    Enable Bubble
    */
    showBubble?: boolean;

    /*
    *    Styling settings for the bubble.
    */
    bubbleStyle?: any;

    /*
    *   Bubble content.
    */
    bubbleContent?: string;

    /**
     * place label below button
     */
    labelBelowButton?: boolean;
}
// -------------------------------------------------------------------------------------------------
export interface IconTextButtonState {
    hover?: boolean;
}
//--------------------------------------------------------------------------------------------------
export interface ButtonData {
    /**
    * Icon's unique ID
    */
    id?: string;
    label?: string;
    onHoverBackgroundColor?: string;
    icon?: {
        type?: "icon" | "img" | "text";
        item?: string;
    }
    onHoverIconImg?: string;

    /**
     * when present, it specifies that the element should be unusable
     */
    disabled?: boolean;

    /**
     * Background image in button area
     */
    backgroundImg?: string;

    /**
     * Tooltip
     */
    tooltip?: string;

    /**
     * Set style per button
     */
    style?: React.CSSProperties;

    /*
     *    Styling settings for icon.
     */
    iconStyle: React.CSSProperties;

    /*
    *    Styling settings for icon caption.
    */
    captionStyle: React.CSSProperties;

    /*
      *   Bubble content.
      */
    bubbleContent?: string;
    bubbleStyle?: React.CSSProperties;
}
// -------------------------------------------------------------------------------------------------
export class IconTextButton extends React.Component<IconTextButtonData, IconTextButtonState> {
    // ---------------------------------------------------------------------------------------------
    constructor(props: IconTextButtonData) {
        super(props);
        this.state = {
            hover: false
        };
    }
    // --------------------------------------------------------------------------------------------
    render() {
        const { button, index, groupIndex: GroupIndex, showBubble, bubbleStyle } = this.props;

        if (!isDefined(button)) {
            return null;
        }
        /**Styling Hierarch for caption and icon */
        const style = { ...button.style, ...this.props.style };
        const captionStyle = { ...button.captionStyle, ...this.props.captionStyle };
        const iconStyle = { ...button.iconStyle, ...this.props.iconStyle };
        const onHoverBackgroundColor = isDefined(button.onHoverBackgroundColor) ? button.onHoverBackgroundColor : "rgba(0,0,0,0.7)";
        let bubbleJSX = (showBubble && !IsNullOrEmpty(button.bubbleContent)) ?
            <div style={{
                position: 'absolute',
                right: 0,
                top: 0,
                transform: 'translate(50%, -50%)',

                /* Center the content */
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '100%',
                paddingLeft: 1,
                paddingRight: 1,
                ...bubbleStyle,
                ...button.bubbleStyle
            }}>

                {button.bubbleContent}
            </div>
            : null;

        // render the inner icon
        let icon = null;
        if (isDefined(button.icon)) {
            switch (button.icon.type) {
                case 'icon':
                    icon = <div style={{ position: 'relative' }}>
                        {bubbleJSX}
                        <i style={iconStyle} className={button.icon.item} />
                    </div>;
                    break;
                case 'img':
                    // apply hover effect
                    let iconImg = button.icon.item;
                    if (this.state.hover && isDefined(button.onHoverIconImg)) {
                        iconImg = button.onHoverIconImg;
                    }
                    icon = <div style={{ position: 'relative' }}>
                        {bubbleJSX}
                        <img style={iconStyle} src={iconImg} />
                    </div>;
                    break;
                case 'text':
                    icon = <div style={{ position: 'relative' }}>
                        {bubbleJSX}
                        <span style={iconStyle}>{button.icon.item}</span>
                    </div>;
                    break;
                default:
                    break;
            }
        }

        let jsx = <div
            key={`nested-items-${button.id}-${index}`}
            style={{
                display: 'flex',
                cursor: button.disabled ? 'initial' : "pointer",
                borderRadius: 15,
                overflow: "hidden",
                backgroundImage: `url(${button.backgroundImg})`,
                backgroundSize: "contain",
                opacity: button.disabled ? 0.25 : 1,
                ...style
            }}
            onClick={() => {
                if (!button.disabled) {
                    this.props.onIconClick(button, GroupIndex);
                }
            }}>
            <div
                onMouseEnter={() => this.setState({ hover: true })}
                onMouseLeave={() => this.setState({ hover: false })}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    padding: 10,
                    backgroundColor: this.state.hover && !button.disabled ? onHoverBackgroundColor : "inherit",
                    width: "100%",
                    height: "100%"
                }}>
                {icon}
                {!this.props.labelBelowButton
                    ? <div
                        key={'nested-items-caption-' + button.id + index}
                        style={captionStyle}>
                        {button.label}
                    </div>
                    : null}
            </div>
        </div>;

        // place label below button?
        if (this.props.labelBelowButton) {
            jsx = <div>
                {jsx}
                <div
                    key={'nested-items-caption-' + button.id + index}
                    style={{
                        ...captionStyle,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        maxWidth: style.width
                    }}>
                    {button.label}
                </div>
            </div>;
        }

        if (IsNullOrWhiteSpace(button.tooltip))
            return jsx;

        return <Tippy
            trigger={'mouseenter'}
            popperOptions={{
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            escapeWithReference: true,
                            boundariesElement: 'window',

                        }
                    }
                ]
            }}
            theme="yodiwo"
            content={button.tooltip}
            placement={'bottom'}>
            {jsx}
        </Tippy>
    }
}
// -------------------------------------------------------------------------------------------------

